{
  "language": {
    "title": "Choix de langue",
    "subtitle": "Sélectionner la langue d’affichage.",
    "saved": "Langue enregistrée.",
    "apply": "Appliquer",
    "applying": "Application…",
    "incomplete": "Traduction partielle — les textes non traduits restent en français.",
    "fr": "Français",
    "en": "Anglais",
    "fon": "Fon",
    "yo": "Yoruba",
    "bba": "Bariba",
    "partial": "Traduction partielle"
  },
  "common": {
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Enregistrer",
    "retry": "Réessayer",
    "loading": "Chargement…",
    "offline": "Hors ligne",
    "back": "Retour",
    "next": "Suivant",
    "close": "Fermer",
    "search": "Rechercher",
    "delete": "Supprimer",
    "edit": "Modifier",
    "send": "Envoyer",
    "yes": "Oui",
    "no": "Non",
    "queued_one": "{{count}} action en attente d’envoi",
    "queued_other": "{{count}} actions en attente d’envoi"
  },
  "nav": {
    "home": "Accueil",
    "request": "Demande",
    "help": "Aide",
    "account": "Compte",
    "dashboard": "Tableau de bord",
    "offers": "Demandes",
    "missions": "Missions",
    "payments": "Paiements",
    "clients": "Clients",
    "providers": "Prestataires",
    "reports": "Signalements",
    "services": "Services",
    "vehicles": "Véhicules",
    "subscription": "Abonnement",
    "advertising": "Publicité & Visibilité",
    "messages": "Messagerie",
    "details": "Détails",
    "dashboardShort": "Tableau"
  },
  "status": {
    "active": "Actif",
    "suspended": "Suspendu",
    "pending": "En attente",
    "inProgress": "En cours",
    "completed": "Terminé",
    "cancelled": "Annulé",
    "rejected": "Rejeté"
  },
  "service": {
    "transportPerson": "Transport de personne",
    "delivery": "Livraison",
    "equipmentRental": "Location d’engin",
    "driverHire": "Mise à disposition de chauffeur"
  }
}
